import { cn } from '@/lib/utils';

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('oche-shimmer rounded-md bg-[var(--color-line)]', className)} aria-hidden />;
}

export function SessionOverviewSkeleton() {
  return (
    <section className="grid gap-6" aria-busy="true" aria-label="Loading session">
      <div className="flex items-baseline justify-between gap-4">
        <div className="grid flex-1 gap-2">
          <Skeleton className="h-8 w-64 max-w-full" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-3 w-48" />
        </div>
        <Skeleton className="h-6 w-20 rounded-full" />
      </div>
      <ul className="grid gap-3">
        {[0, 1, 2].map((i) => (
          <li
            key={i}
            className="flex items-center justify-between rounded-lg border border-[var(--color-line)] bg-[var(--color-surface)] px-4 py-3"
          >
            <span className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-full" />
              <Skeleton className="h-5 w-28" />
            </span>
            <Skeleton className="h-8 w-32" />
          </li>
        ))}
      </ul>
    </section>
  );
}

export function HistoryListSkeleton() {
  return (
    <ul className="grid gap-2" aria-busy="true" aria-label="Loading history">
      {[0, 1, 2, 3].map((i) => (
        <li
          key={i}
          className="flex items-center gap-4 rounded-lg border border-[var(--color-line)] bg-[var(--color-surface)] px-4 py-3"
        >
          <Skeleton className="h-11 w-20 shrink-0 rounded" />
          <span className="grid flex-1 gap-2">
            <Skeleton className="h-5 w-48 max-w-full" />
            <Skeleton className="h-4 w-36" />
          </span>
        </li>
      ))}
    </ul>
  );
}

export function SessionDetailSkeleton() {
  return (
    <article className="grid gap-6" aria-busy="true" aria-label="Loading session detail">
      <header className="grid gap-2">
        <Skeleton className="h-8 w-72 max-w-full" />
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-4 w-24" />
      </header>
      <Skeleton className="aspect-video w-full max-w-3xl rounded-lg" />
      <ul className="grid gap-2">
        {[0, 1].map((i) => (
          <li
            key={i}
            className="flex items-center justify-between rounded-lg border border-[var(--color-line)] bg-[var(--color-surface)] px-4 py-3"
          >
            <span className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-full" />
              <Skeleton className="h-5 w-24" />
            </span>
            <Skeleton className="h-8 w-12" />
          </li>
        ))}
      </ul>
    </article>
  );
}
